import WriteOffApproval from "./WriteOffApproval";

export default function RefundApproval() {
    return (
        <WriteOffApproval
            title="Refund Approval"
            initialSearchValue={{ reason: "refund" }}
            filterWriteOffs={(writeOff) =>
                writeOff?.type === "OVERPAID" && writeOff?.reason === "refund"
            }
        />
    );
}
